import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { ACTIONS } from '../../actions/actionTypes';
import Spinner from '../components/spinner';

class SimpleModal extends Component {
    render () {
        if (!this.props.isSimpleModalOpened) {
            return null;
        }

        const title = this.props.userMission.mission.title;
        const text = this.props.userMission.mission.description;

        return (
            <div style={overlayStyle}>
                <div style={modalStyle}>
                    {(this.props.loading)
                        ? <Spinner />
                        : <div>
                            <h1>{title}</h1>
                            <span>{text}</span>
                            <div style={buttonsWrapperStyle}>
                                <div className='btn modal' onClick={() => {
                                    this.props.simpleModalClose();
                                }}>
                                    <h4>Agora não</h4>
                                </div>
                                <div className='btn modal' onClick={() => {
                                    this.props.acceptSession(this.props.userMission);
                                }}>
                                    <h4>Aceitar Missão</h4>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
};

const overlayStyle = {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    zIndex: '100',
    overflow: 'auto',
    backgroundColor: 'rgba(0,0,0,0.6)'
};

const modalStyle = {
    zIndex: '101',
    width: '85%',
    maxHeight: '80%',
    overflowY: 'scroll',
    background: '#333',
    backgroundColor: '#fefefe',
    padding: '20px',
    border: '1px solid #888',
    borderRadius: 5,
    boxShadow: '0 12px 15px 0 rgba(0, 0, 0, 0.25)'
};

const buttonsWrapperStyle = {
    display: 'flex',
    justifyContent: 'spcae-around',
    width: '100%',
    marginTop: '20px'
};

const mapStateToProps = ({simpleModalReducer, questionReducer}) => {
    const {userMission, isSimpleModalOpened} = simpleModalReducer;
    const {loading} = questionReducer;
    return {userMission, isSimpleModalOpened, loading};
};

const mapActionsToProps = (dispatch) => ({
    push: (param) => dispatch(push(param)),
    acceptSession: (userMission) => dispatch({
        type: ACTIONS.ACCEPT_SESSION,
        payload: userMission
    }),
    simpleModalClose: () => dispatch({
        type: ACTIONS.CLOSE_SIMPLE_MODAL
    })
});

export default connect(mapStateToProps, mapActionsToProps)(SimpleModal);



// WEBPACK FOOTER //
// ./src/views/simpleModalView/simpleModal.js